





























































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { IBlock, ISortParameters } from "@/interfaces";
import CryptoCompareService from "@/services/crypto-compare";
import { mapGetters } from "vuex";

@Component({
  computed: {
    ...mapGetters("network", ["isListed"]),
  },
})
export default class TableBlocksDesktop extends Vue {
  @Prop({
    required: true,
    validator: (value) => {
      return Array.isArray(value) || value === null;
    },
  })
  public blocks: IBlock[] | null;
  @Prop({ required: false, default: false }) public hideGeneratedBy: boolean;
  private isListed: boolean;

  get columns() {
    let columns = [
      {
        label: this.$t("COMMON.ID"),
        field: "id",
        thClass: "start-cell w-80",
        tdClass: "start-cell w-80",
      },
      {
        label: this.$t("COMMON.HEIGHT"),
        field: "height",
        type: "number",
        thClass: "text-center hidden md:table-cell ",
        tdClass: "text-center hidden md:table-cell wrap-timestamp",
      },
      {
        label: this.$t("COMMON.TIMESTAMP"),
        field: "timestamp",
        type: "number",
        thClass: "text-center hidden md:table-cell",
        tdClass: "text-center hidden md:table-cell wrap-timestamp",
      },
      {
        label: this.$t("COMMON.TRANSACTIONS"),
        field: "transactions",
        type: "number",
        thClass: "text-center",
        tdClass: "text-center",
      },
      {
        label: this.$t("BLOCK.MINED_BY"),
        field: "generator.username",
        thClass: "end-cell text-center hidden lg:table-cell",
        tdClass: "end-cell text-center hidden lg:table-cell",
      },
    ];

    if (this.hideGeneratedBy) {
      columns = columns.filter((column) => column.field !== "generator.username");
    }

    return columns;
  }

  get currencySymbol() {
    return this.$store.getters["currency/symbol"];
  }

  private emitSortChange(params: ISortParameters[]) {
    this.$emit("on-sort-change", params[0]);
  }
}
